import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { withStyles } from '@material-ui/core';
import styles from '../../screens/Notifications/styles';

class NotificationStatus extends React.PureComponent {
  render() {
    const { t, classes } = this.props;

    return (
      <React.Fragment>
        <div className={classes.errorMessage}>{t('welcome.notification_status')}</div>
      </React.Fragment>
    );
  }
}

NotificationStatus.propTypes = {
  t: PropTypes.any.isRequired,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(withTranslation()(NotificationStatus));
